/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileCopyEndpointRequest
 */
export interface FileCopyEndpointRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileCopyEndpointRequest
     */
    input: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FileCopyEndpointRequest
     */
    destination: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileCopyEndpointRequest
     */
    hardlink?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileCopyEndpointRequest
     */
    sync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileCopyEndpointRequest
     */
    overwrite?: FileCopyEndpointRequestOverwriteEnum;
    /**
     * 
     * @type {string}
     * @memberof FileCopyEndpointRequest
     */
    folders?: FileCopyEndpointRequestFoldersEnum;
}

/**
* @export
* @enum {string}
*/
export enum FileCopyEndpointRequestOverwriteEnum {
    Null = 'null',
    Warn = 'warn',
    Number = 'number',
    Timestamp = 'timestamp',
    Overwrite = 'overwrite'
}/**
* @export
* @enum {string}
*/
export enum FileCopyEndpointRequestFoldersEnum {
    Merge = 'merge',
    Rename = 'rename'
}

export function FileCopyEndpointRequestFromJSON(json: any): FileCopyEndpointRequest {
    return FileCopyEndpointRequestFromJSONTyped(json, false);
}

export function FileCopyEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileCopyEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
        'destination': json['destination'],
        'hardlink': !exists(json, 'hardlink') ? undefined : json['hardlink'],
        'sync': !exists(json, 'sync') ? undefined : json['sync'],
        'overwrite': !exists(json, 'overwrite') ? undefined : json['overwrite'],
        'folders': !exists(json, 'folders') ? undefined : json['folders'],
    };
}

export function FileCopyEndpointRequestToJSON(value?: FileCopyEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
        'destination': value.destination,
        'hardlink': value.hardlink,
        'sync': value.sync,
        'overwrite': value.overwrite,
        'folders': value.folders,
    };
}


